
import * as APIUtil from '../util/session_api_util';
import * as UserAPIUtil from '../util/users_util';

export const RECEIVE_USER_INFO = "RECEIVE_USER_INFO";
export const RECEIVE_UPDATED_USER_INFO = "RECEIVE_UPDATED_USER_INFO";
export const RECEIVE_UPDATED_MASTER= "RECEIVE_UPDATED_MASTER";
export const RECEIVE_MASTERS = "RECEIVE_MASTERS";
export const RECEIVE_STUDENTS = "RECEIVE_STUDENTS";
export const RECEIVE_UPDATED_STUDENT = "RECEIVE_UPDATED_STUDENT"
export const RECEIVE_MY_STUDENTS = "RECEIVE_MY_STUDENTS";
export const RECEIVE_CURRENT_USER = "RECEIVE_CURRENT_USER";
export const ADD_COURSES_TO_MASTER = "ADD_COURSES_TO_MASTER";
export const RECEIVE_USER_ERRORS = "RECEIVE_USER_ERRORS"
export const RECEIVE_SEARCH_RESULTS = "RECEIVE_SEARCH_RESULTS";
export const RECEIVE_SEARCH_ERRORS = "RECEIVE_SEARCH_ERRORS";
export const ENROLL_STUDENT_IN_COURSE = "ENROLL_STUDENT_IN_COURSE";
export const RECEIVE_ENROLLMENT_ERRORS = "RECEIVE_ENROLLMENT_ERRORS";
export const REMOVE_COURSE_FROM_STUDENT = "REMOVE_COURSE_FROM_STUDENT";
export const RECEIVE_UPDATED_PROFILE = "RECEIVE_UPDATED_PROFILE";
export const RECEIVE_CREDITS = "RECEIVE_CREDITS";


export const receiveCurrentUser = (user) => ({
    type: RECEIVE_CURRENT_USER,
    payload: user,
  });

export const receiveUserInfo = user => ({
    type: RECEIVE_USER_INFO,
    user
})

export const receiveUpdatedProfile = (profile) => ({
    type: RECEIVE_UPDATED_PROFILE,
    profile,
  });


export const receiveUpdatedUserInfo = updated => ({
    type: RECEIVE_UPDATED_USER_INFO,
    updated
})

export const receiveUpdatedMaster = updatedMaster => ({
    type: RECEIVE_UPDATED_MASTER,
    updatedMaster
})

export const receiveMasters = masters => ({
    type: RECEIVE_MASTERS,
    masters
})

export const receiveStudents = students => ({
    type: RECEIVE_STUDENTS,
    students
})

// Action Creators
export const receiveSearchResults = (students) => ({
    type: RECEIVE_SEARCH_RESULTS,
    students,
  });
  
  export const receiveSearchErrors = (errors) => ({
    type: RECEIVE_SEARCH_ERRORS,
    errors,
  });
  

export const receiveMyStudents = myStudents => ({
    type: RECEIVE_MY_STUDENTS,
    myStudents
})

export const receiveUpdatedStudent = updatedStudent => ({
    type: RECEIVE_UPDATED_STUDENT,
    updatedStudent
})

export const addCoursesToMasterSuccess = (user) => ({
    type: ADD_COURSES_TO_MASTER,
    user,
  });


  export const enrollStudentInCourseSuccess = (student) => ({
    type: ENROLL_STUDENT_IN_COURSE,
    student,
  });

  export const removeCourseFromStudentSuccess = (updatedStudent) => ({
    type: REMOVE_COURSE_FROM_STUDENT,
    updatedStudent,
  });
  
  export const receiveEnrollmentErrors = (errors) => ({
    type: RECEIVE_ENROLLMENT_ERRORS,
    errors,
  });
  // Action to handle errors
export const receiveErrors = (errors) => ({
    type: RECEIVE_USER_ERRORS,
    errors,
  });


  export const receiveCredits = (profile) => ({
    type: RECEIVE_CREDITS,
    profile, // Store full profile in Redux (includes credits)
  });
  



export const fetchUser = (id) => dispatch => {
    APIUtil.fetchUser(id).then(user => {
        dispatch(receiveUserInfo(user))
    })
}

export const fetchMasters = () => dispatch => {
    UserAPIUtil.fetchMasters().then(masters => {
        dispatch(receiveMasters(masters))
    })
}

export const approveMaster = (id) => (dispatch) => {
  return UserAPIUtil.approveMaster(id).then((res) => {
    dispatch(receiveUpdatedMaster(res.data));
    return res.data; // so callers can await if they want
  });
};


export const searchStudents = (searchTerm) => (dispatch) => {
    return UserAPIUtil.searchStudents(searchTerm)
      .then((res) => {
        dispatch(receiveSearchResults(res.data)); // Dispatch successful results
      })
      .catch((err) => {
        const errorMessage =
          err.response && err.response.status === 404
            ? "No students found with that name or email."
            : "An error occurred. Please try again.";
        dispatch(receiveSearchErrors(errorMessage)); // Dispatch error message
      });
  };
export const fetchStudents = (id) => dispatch => {
    UserAPIUtil.fetchStudents(id).then(myStudents => {
        dispatch(receiveMyStudents(myStudents))
    })
}

export const updateStudent = (id, masterId) => dispatch => {
    UserAPIUtil.updateStudent(id, masterId).then(updatedStudent => {
        dispatch(receiveUpdatedStudent(updatedStudent))
    })
}

export const fetchCurrentUser = (userId) => (dispatch) => {
    return UserAPIUtil.fetchUser(userId)
      .then((res) => {
        dispatch(receiveCurrentUser(res.data));
      })
      .catch((err) => {
        console.error("Error fetching current user:", err);
      });
  };

  export const updateCredits = (userId, credits) => (dispatch) => {
    return UserAPIUtil.updateCredits(userId, credits)
      .then((updatedProfile) => dispatch(receiveUpdatedProfile(updatedProfile.data)))
      .catch((err) => console.error("Error updating credits:", err));
  };

export const updateCurrentUser = (userId, data) => (dispatch) => {
  // Ensure this returns a Promise
    UserAPIUtil.updateCurrentUser(userId, data).then((res) => {
    dispatch(receiveCurrentUser(res.data)); // Dispatch updated user to Redux store
    return res.data; // Pass updated user back to caller
  });
};


export const addCoursesToMaster = (userId, courseIds) => async (dispatch) => {
    try {
      const response = await UserAPIUtil.addCoursesToMaster(userId, courseIds);
      dispatch(addCoursesToMasterSuccess(response.data));
    } catch (error) {
      console.error("Error adding courses to master:", error);
    }
  };

  // Remove courses from a master's eligible courses
export const removeCoursesFromMaster = (masterId, courseIds) => (dispatch) => {
    return UserAPIUtil.removeCoursesFromMaster(masterId, courseIds)
      .then((res) => dispatch(receiveMasters(res.data)))
      .catch((err) => dispatch(receiveErrors(err.response.data)));
  };

  export const enrollStudentInCourse = (studentId, courseId) => (dispatch) => {
    return UserAPIUtil.enrollStudentInCourse(studentId, courseId)
      .then((res) => dispatch(enrollStudentInCourseSuccess(res.data)))
      .catch((err) =>
        dispatch(receiveEnrollmentErrors(err.response ? err.response.data : err))
      );
  };

  // Thunk action to remove a student from a course
export const removeStudentFromCourse = (studentId, courseId) => async (dispatch) => {
    try {
      const response = await UserAPIUtil.removeStudentFromCourse(studentId, courseId);
      dispatch(removeCourseFromStudentSuccess(response.data));
    } catch (error) {
      console.error("Error removing student from course:", error);
    }
  };

  export const fetchCredits = (userId) => (dispatch) => {
    return UserAPIUtil.fetchCredits(userId)
      .then((res) => dispatch(receiveCredits(res.data)))
      .catch((err) => console.error("Error fetching credits:", err));
  };